import Image from "next/image";

import { cn } from "@/lib/utils";

import { PreviewCanvasScale } from "./shared/preview-canvas-scale";

const CHECKBOX_CHECKED = "/assets-next/tools/previews/svg/checkbox-checked.svg";
const CHECKBOX_UNCHECKED =
  "/assets-next/tools/previews/svg/checkbox-unchecked.svg";

/** Checklist rows — Figma 11115:59217–59229 within 11115:59216. */
const CHECKLIST_ROWS = [
  {
    label: "Have you decided your headline offer",
    checked: true,
    top: 0,
    opacity: undefined,
  },
  {
    label: "Have you checked the margin maths",
    checked: false,
    top: 41.438,
    opacity: "opacity-20",
  },
  {
    label: "Have you set a margin floor you won't discount past",
    checked: false,
    top: 82.876,
    opacity: "opacity-[0.08]",
  },
] as const;

/**
 * Readiness checklist inset (Figma 11115:59211, 391×291).
 * Scales down on the mobile preview shell (243×181) and renders 1:1 from md+.
 */
export function ReadinessChecklistPreview() {
  return (
    <PreviewCanvasScale testId="readiness-checklist-canvas">
      {/* Frame 19 — Figma 11115:59212 at 30×30 */}
      <div className="absolute top-[30px] left-[30px] h-[145.315px] w-[380.021px]">
        {/* Offer — Figma 11115:59215 at 0×0 */}
        <p className="text-grey-950 absolute top-0 left-0 text-[12px] leading-[1.4] font-normal whitespace-nowrap">
          Offer
        </p>

        {/* Frame 2147225442 — Figma 11115:59216 at y=29 */}
        <div className="absolute top-[29px] left-0 h-[116.315px] w-[379.275px]">
          {CHECKLIST_ROWS.map((row) => (
            <div
              key={row.label}
              className={cn(
                "absolute left-0 h-[33.438px] w-[379.275px] rounded-[6px] shadow-[inset_0_0_0_0.8px_var(--color-grey-100)]",
                row.opacity
              )}
              style={{ top: row.top }}
            >
              <Image
                src={row.checked ? CHECKBOX_CHECKED : CHECKBOX_UNCHECKED}
                alt=""
                width={16}
                height={16}
                className="absolute top-[8.719px] left-[11.625px] size-4"
                aria-hidden
              />
              <p className="text-grey-950 absolute top-[8.719px] left-[36.345px] h-[16px] w-[331.305px] text-[11.625px] leading-[1.4] font-medium">
                {row.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </PreviewCanvasScale>
  );
}
